module.exports = __webpack_public_path__ + "img/cam_10_on.bbd2a201.png";